// ================================
// Carousel JavaScript
// ================================
$(document).ready(function () {

  $(".owl-carousel").owlCarousel();

  $('.testimonial').owlCarousel({
    loop: true,
    responsiveClass: true,
    dots: true,
    margin: 40,
    responsive: {
      0: { items: 2, nav: true, margin: 5 },
      600: { items: 2, nav: false },
      1000: { items: 2, nav: true, loop: false },
      1200: { items: 3, nav: true, loop: false }
    }
  });

  $('.Flip_carousel').owlCarousel({
    loop: true,
    responsiveClass: true,
    dots: false,
    margin: 40,
    autoplay: true,
    autoplayTimeout: 5000,
    merge: true,
    autoplayHoverPause: false,
    nav: false,
    responsive: {
      0: { items: 1, nav: false, margin: 5 },
      600: { items: 1, nav: false },
      1000: { items: 2, nav: true },
      1200: { items: 3, nav: true }
    }
  });

  $('.full_width .owl-carousel').owlCarousel({
    loop: true,
    responsiveClass: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    nav: false,
    responsive: {
      0: { items: 1 },
      1200: { items: 1 }
    }
  });

  $('.owl-carousel').owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    dots: false,
    responsive: {
      0: { items: 2, nav: true },
      600: { items: 3, nav: false },
      1000: { items: 5, nav: true, loop: false }
    }
  });

  // ================================
  // Instagram filtration JavaScript
  // ================================
  $(window).on('load', function () {
    $('.instagram-gallery-medium a').children().filter("video").each(function () {
      $(this).parent().remove();
    });
  });

  // ================================
  // Make all multicard clickable
  // ================================
  jQuery("#Slider-template--14790728974372__49d2f0fd-2527-439a-8660-c7f467250a5c .multicolumn-card, #Slider-template--14790728974372__efaccf41-f248-4d10-bb3b-abe3d9530ea4 .multicolumn-card").click(function () {
    window.location = $(this).find("a").attr("href");
    return false;
  });

  jQuery("#shopify-section-template--14790728974372__multicolumn_XzBjBd .multicolumn-card, #Slider-template--14790728974372__b06b21f4-195b-4f87-80ee-6af7a681673b .multicolumn-card").click(function () {
    window.location = $(this).find("a").attr("href");
    return false;
  });

  jQuery("#shopify-section-template--14790728974372__multicolumn_pnjieh .multicolumn-card").click(function () {
    window.location = $(this).find("a").attr("href");
    return false;
  });


  // ================================
  // Scroll behavior
  // ================================
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 10) {
      $("body").addClass("on-scroll_show");
    } else {
      $("body").removeClass("on-scroll_show");
    }
  });

}); // ✅ END document.ready


// ================================
// LocalStorage Collection Popups
// ================================
if (localStorage.getItem("event_URL") !== "events") {
  if (window.location.href === "https://www.aiwaflowers.ae/collections/events-decoration") {
    setTimeout(function () {
      $('.collection_popup').addClass("show_popup");
    }, 6000);
    $(".close_popup").click(function () {
      $('.collection_popup').removeClass("show_popup");
    });
    localStorage.setItem("event_URL", "events");
  }
}

if (localStorage.getItem("bridal_URL") !== "bridal") {
  if (window.location.href === "https://www.aiwaflowers.ae/collections/bridal-flower-bouquet") {
    setTimeout(function () {
      $('.collection_popup').addClass("show_popup");
    }, 6000);
    $(".close_popup").click(function () {
      $('.collection_popup').removeClass("show_popup");
    });
    localStorage.setItem("bridal_URL", "bridal");
  }
}

// ================================
// Valentine PDP Value Line (SAFE)
// ================================
(function () {

  const map = {
    "Cupid’s Kiss": "A timeless Valentine’s gift — 35 premium red roses, elegantly wrapped.",
    "Elegant Whispers": "A bold Valentine’s statement — 55 red roses with heart details in sleek black wrap.",
    "Forever Yours": "The grandest Valentine’s gesture — 201 velvety red roses in a luxurious dome bouquet.",
    "In my Heart": "Romantic elegance for Valentine’s — 25–35 red roses with a golden accent in a heart box.",
    "Love Key": "A meaningful Valentine’s keepsake — ‘A Key To My Heart’ vintage token of love.",
    "Love Notes": "Classic Valentine’s charm — 25 premium red roses, beautifully wrapped in white.",
    "Love, Wrapped": "A grand Valentine’s declaration — 101 radiant red roses in a pure white wrap.",
    "Lux Dream": "Romantic and unforgettable — 101 red roses with ribbons and heart charms.",
    "Stolen Heart": "The ultimate Valentine’s gesture — 501 red roses crafted in a heart-shaped design.",
    "Strawberry Kisses": "Sweet Valentine’s delight — juicy strawberries in a heart box with satin ribbon.",
    "Sweet Obsession": "A fresh Valentine’s twist — premium strawberries arranged in a romantic bouquet.",
    "Trio Red Infinity Roses": "Everlasting Valentine’s romance — 3 preserved red roses under a crystal-clear dome.",
    "You & Me": "Passion and sweetness for Valentine’s — 25 red roses with a heart box of strawberries.",
    "1001 Reasons to Love": "An unforgettable Valentine’s legacy — 1001 premium red roses in a heart bouquet.",
    "Single Red Infinity Rose": "A lasting Valentine’s symbol — one preserved red rose under glass that stays beautiful for years."
  };

  if (!document.querySelector('.product__title h1, h1.product__title, h1')) return;

  function getTitle() {
    const h1 = document.querySelector('.product__title h1') || document.querySelector('h1');
    return h1 ? h1.textContent.trim() : "";
  }

  function inject() {
    if (document.getElementById('aiwa-valentine-value-line')) return;
    const line = map[getTitle()];
    if (!line) return;

    const price = document.querySelector('.price') || document.querySelector('[data-price]');
    if (!price) return;

    const el = document.createElement('div');
    el.id = 'aiwa-valentine-value-line';
    el.className = 'aiwa-valentine-value-line';
    el.innerHTML = `<span class="heart">❤</span><span>${line}</span>`;
    price.insertAdjacentElement('afterend', el);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', inject)
    : inject();

  document.addEventListener('shopify:section:load', inject);
  document.addEventListener('variant:change', inject);

})();


// ================================
// Free Delivery + Time-based Availability + Trust Lines (FINAL)
// ================================
(function () {

  window.AIWA_DELIVERY_NOTE_VERSION = "v3-2026-03-18";

  const ID = 'aiwa-free-delivery-line';
  const NOTE_ID = 'aiwa-delivery-availability-note';
  const VIDEO_ID = 'aiwa-video-approval-line';
  const FRESH_ID = 'aiwa-fresh-flower-line';

  const PRICE_SELECTORS = [
    '.no-js-hidden[id^="price-template"]',
    '.price.price--large.price--on-sale.price--show-badge',
    '.price.price--large',
    '.price',
    '[data-testid="product-price"]',
    '[data-price]',
    '.product__info-container .price'
  ];

  function findAnchorEl() {
    for (const sel of PRICE_SELECTORS) {
      const el = document.querySelector(sel);
      if (!el) continue;

      if (el.classList && el.classList.contains('price') && el.parentElement) {
        return el.parentElement;
      }
      return el;
    }
    return null;
  }

  function getDubaiAvailabilityMessage() {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Dubai",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(new Date());

    const get = (t) => parts.find(p => p.type === t)?.value;
    const hh = Number(get("hour"));
    const mm = Number(get("minute"));

    const isAfter8 = (hh > 8) || (hh === 8 && mm >= 0);

    return isAfter8
      ? "Delivery available today in Dubai & Sharjah. For other UAE areas, please confirm availability with our customer service team."
      : "Delivery available today after 8:00AM (Abu Dhabi time).";
  }

function runAll() {
  if (!document.querySelector('.product__title h1, h1.product__title, .product, .product__info-container')) return;

  const anchor = findAnchorEl();
  if (!anchor) return;

  // VIDEO APPROVAL LINE
  let videoLine = document.getElementById(VIDEO_ID);
  if (!videoLine) {
    videoLine = document.createElement('div');
    videoLine.id = VIDEO_ID;
    videoLine.className = 'aiwa-delivery-availability-note';
    videoLine.innerHTML = `
      <span class="aiwa-free-icon">🎥</span>
      <span class="aiwa-free-text">
        Video Approval <strong>Before Delivery</strong>
      </span>
    `;
  }

  // FRESH FLOWER GUARANTEE LINE
  let freshLine = document.getElementById(FRESH_ID);
  if (!freshLine) {
    freshLine = document.createElement('div');
    freshLine.id = FRESH_ID;
    freshLine.className = 'aiwa-delivery-availability-note';
    freshLine.innerHTML = `
      <span class="aiwa-free-icon">🌸</span>
      <span class="aiwa-free-text">
        <strong>Fresh Flower Guarantee</strong>
      </span>
    `;
  }

  // FREE DELIVERY LINE
  let freeLine = document.getElementById(ID);
  if (!freeLine) {
    freeLine = document.createElement('div');
    freeLine.id = ID;
    freeLine.className = 'aiwa-delivery-availability-note';
    freeLine.innerHTML = `
      <span class="aiwa-free-icon">🚚</span>
      <span class="aiwa-free-text">
        Free & Fast Delivery in <strong>Dubai & Sharjah</strong>
      </span>
    `;
  }

  if (anchor.nextElementSibling !== videoLine) {
    anchor.insertAdjacentElement('afterend', videoLine);
  }

  if (videoLine.nextElementSibling !== freshLine) {
    videoLine.insertAdjacentElement('afterend', freshLine);
  }

  if (freshLine.nextElementSibling !== freeLine) {
    freshLine.insertAdjacentElement('afterend', freeLine);
  }

  // NOTE (deduped)
  const msg = getDubaiAvailabilityMessage();

  document.querySelectorAll(`#${NOTE_ID}`).forEach((el, i) => {
    if (i > 0) el.remove();
  });

  const duplicateText = "Delivery available today in Dubai & Sharjah. For other UAE areas, please confirm availability with our customer service team.";
  document.querySelectorAll('.aiwa-delivery-availability-note').forEach((el) => {
    const textEl = el.querySelector('.aiwa-free-text');
    if (
      el.id !== NOTE_ID &&
      textEl &&
      textEl.textContent.trim() === duplicateText
    ) {
      el.remove();
    }
  });

  let note = document.getElementById(NOTE_ID);

  if (!note) {
    note = document.createElement('div');
    note.id = NOTE_ID;
    note.className = 'aiwa-delivery-availability-note';
    note.innerHTML = `
      <span class="aiwa-free-icon">⏰</span>
      <span class="aiwa-free-text"></span>
    `;
  }

  note.querySelector('.aiwa-free-text').textContent = msg;

  if (freeLine.nextElementSibling !== note) {
    freeLine.insertAdjacentElement('afterend', note);
  }
}

// init
document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', runAll)
  : runAll();

document.addEventListener('shopify:section:load', runAll);
document.addEventListener('variant:change', runAll);

let t = null;
const mo = new MutationObserver(function () {
  if (t) return;
  t = setTimeout(() => { t = null; runAll(); }, 50);
});
mo.observe(document.documentElement, { childList: true, subtree: true });

})();